export default __webpack_public_path__ + "static/media/snake_one.6f8022b6.png";